import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="global-user-companies-search"
export default class extends Controller {
  static targets = ["overlay", "input"]
  static values = { 
    isOpen: Boolean 
  }

  openOnKeyboard(event) {
    event.preventDefault()
    this.open()
  }

  closeOnEscape() {
    if (this.isOpenValue) {
      this.close()
    }
  }

  open() {
    this.isOpenValue = true
    this.overlayTarget.classList.remove('hidden')
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  close() {
    this.isOpenValue = false
    this.overlayTarget.classList.add('hidden')
    this.inputTarget.value = ''
  }

  handleSubmit(event) {
    const email = this.inputTarget.value.trim()
    
    if (!this.isValidEmail(email)) {
      event.preventDefault()
      this.showError('Please enter a valid email address')
    }
  }

  isValidEmail(email) {
    const emailRegex = /^[\w+\-.]+@[a-z\d\-]+(\.[a-z\d\-]+)*\.[a-z]+$/i
    return emailRegex.test(email)
  }

  showError(message) {
    const existingError = this.overlayTarget.querySelector('.error-message')
    if (existingError) {
      existingError.remove()
    }

    const errorDiv = document.createElement('div')
    errorDiv.className = 'error-message bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md mx-8 mb-4 mt-4'
    errorDiv.textContent = message

    const form = this.overlayTarget.querySelector('form')
    form.parentNode.insertBefore(errorDiv, form.nextSibling)

    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.remove()
      }
    }, 3000)
  }
}
